import {DateTime} from "luxon";

const BASE_DATE_FORMAT = "yyyy-MM-dd'T'hh:mm:ss";

export const localeDateFormat = "MM/dd/yyyy";

export const getDateTime = (date, initFormat = BASE_DATE_FORMAT) => {
    if (!date) return null;
    if (date instanceof DateTime) return date;
    if (date instanceof Date) return DateTime.fromJSDate(date);
    if (typeof date !== "string") return null;

    return DateTime.fromFormat(date, initFormat);
};

export const formatTo = (date, format, initFormat = BASE_DATE_FORMAT) => {
    if (!date) return "";

    let dt;

    if (/^\d{4}-\d{2}-\d{2}T/.test(date)) {
        dt = DateTime.fromISO(date, {zone: "utc"});
    } else if (date instanceof DateTime) {
        dt = date;
    } else if (date instanceof Date) {
        dt = DateTime.fromJSDate(date);
    } else if (typeof date === "string") {
        dt = DateTime.fromFormat(date, initFormat);
    } else {
        return "";
    }

    return dt.isValid ? dt.toFormat(format) : "";
};

export const formatToISO = (dateString) => `${dateString}T00:00:00`;

export const formatFromISOToDate = (date) => {
    return DateTime.fromISO(date).toFormat("yyyy-MM-dd");
};

export const subtractYears = (years) => DateTime.now().minus({years}).toJSDate();
